import {CHAT} from "./chatActionTypes";

export function setChatId(chatId) {
    return {
        type: CHAT.SET_CHAT_ID,
        payload: chatId
    };
}

export function setTypeChat(type) {
    return {
        type: CHAT.SET_TYPE_CHAT,
        payload: type
    };
}

export function setAddMessagesSentArr(arr) {
    return {
        type: CHAT.SET_ADD_MESSAGES_SENT_ARR,
        payload: arr
    };
}
export function removeFirstMatchMessageFromArr(text) {
    return {
        type: CHAT.REMOVE_FIRST_MATCHING_MESSAGE,
        payload: text
    };
}
export function clearSentArr() {
    return {
        type: CHAT.CLEAR_SENT_ARR,
    };
}
